import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import { FormFilesInputLoading } from '@/_containers/inputs/media/form-files-input';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-6" /> {/* conference_name */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-6" /> {/* conference_host */}
              <InputSkeleton className="col-span-12 sm:col-span-4" /> {/* start_date */}
              <InputSkeleton className="col-span-12 sm:col-span-4" /> {/* end_date */}
              <InputSkeleton className="col-span-12 sm:col-span-4" /> {/* sponsor */}
              <InputSkeleton className="col-span-12" /> {/* notes */}
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <InputSkeleton className="col-span-12" /> {/* event_location_type */}
              <InputSkeleton className="col-span-12" /> {/* virtual_link or physical_address */}
            </FormLayout>
          </CardContainer>
          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <FormFilesInputLoading className="col-span-12" /> {/* attachments */}
            </FormLayout>
          </CardContainer>

          <div className="flex flex-col gap-4 md:flex-row">
            <CardContainer className="flex-1">
              <FormLayout>
                <SectionHeadingSkeleton />
                <InputSkeleton className="col-span-12" /> {/* team_member_attending */}
              </FormLayout>
            </CardContainer>

            <CardContainer className="flex-1">
              <FormLayout>
                <SectionHeadingSkeleton />
                <InputSkeleton className="col-span-12" /> {/* attendees */}
              </FormLayout>
            </CardContainer>
          </div>
        </LeftSection>
        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton />
            <PhoneNumberLoading />
          </CardContainer>
          <CardContainer right>
            <SectionHeadingSkeleton />
            <PhoneNumberLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
